/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DocumentDto } from '../models/document-dto';
import { DocumentMetadataDto } from '../models/document-metadata-dto';
import { ProcessResponse } from '../models/process-response';

@Injectable({
  providedIn: 'root',
})
export class DocumentService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiDocumentDocumentKeyGet
   */
  static readonly ApiDocumentDocumentKeyGetPath = '/api/Document/{documentKey}';

  /**
   * Get a single document by key.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocumentDocumentKeyGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocumentDocumentKeyGet$Json$Response(params: {
    documentKey: number;

  }): Observable<StrictHttpResponse<DocumentDto>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentService.ApiDocumentDocumentKeyGetPath, 'get');
    if (params) {

      rb.path('documentKey', params.documentKey, {});

    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DocumentDto>;
      })
    );
  }

  /**
   * Get a single document by key.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDocumentDocumentKeyGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocumentDocumentKeyGet$Json(params: {
    documentKey: number;

  }): Observable<DocumentDto> {

    return this.apiDocumentDocumentKeyGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DocumentDto>) => r.body as DocumentDto)
    );
  }

  /**
   * Path part for operation apiDocumentDocumentKeyDelete
   */
  static readonly ApiDocumentDocumentKeyDeletePath = '/api/Document/{documentKey}';

  /**
   * Delete document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocumentDocumentKeyDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocumentDocumentKeyDelete$Json$Response(params: {
    documentKey: number;

  }): Observable<StrictHttpResponse<ProcessResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentService.ApiDocumentDocumentKeyDeletePath, 'delete');
    if (params) {

      rb.path('documentKey', params.documentKey, {});

    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProcessResponse>;
      })
    );
  }

  /**
   * Delete document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDocumentDocumentKeyDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocumentDocumentKeyDelete$Json(params: {
    documentKey: number;

  }): Observable<ProcessResponse> {

    return this.apiDocumentDocumentKeyDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  /**
   * Path part for operation apiDocumentDocumentKeyDownloadGet
   */
  static readonly ApiDocumentDocumentKeyDownloadGetPath = '/api/Document/{documentKey}/download';

  /**
   * Download the file.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocumentDocumentKeyDownloadGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocumentDocumentKeyDownloadGet$Response(params: {
    documentKey: number;

  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentService.ApiDocumentDocumentKeyDownloadGetPath, 'get');
    if (params) {

      rb.path('documentKey', params.documentKey, {});

    }
    return this.http.request(rb.build({
      responseType: 'blob',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Download the file.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDocumentDocumentKeyDownloadGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocumentDocumentKeyDownloadGet(params: {
    documentKey: number;

  }): Observable<void> {

    return this.apiDocumentDocumentKeyDownloadGet$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiDocumentDocumentKeyMetadataPost
   */
  static readonly ApiDocumentDocumentKeyMetadataPostPath = '/api/Document/{documentKey}/metadata';

  /**
   * Update a document's metadata.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocumentDocumentKeyMetadataPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDocumentDocumentKeyMetadataPost$Json$Response(params: {
    documentKey: number;
      body?: DocumentMetadataDto
  }): Observable<StrictHttpResponse<ProcessResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentService.ApiDocumentDocumentKeyMetadataPostPath, 'post');
    if (params) {

      rb.path('documentKey', params.documentKey, {});

      rb.body(params.body, 'application/*+json');
    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProcessResponse>;
      })
    );
  }

  /**
   * Update a document's metadata.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDocumentDocumentKeyMetadataPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDocumentDocumentKeyMetadataPost$Json(params: {
    documentKey: number;
      body?: DocumentMetadataDto
  }): Observable<ProcessResponse> {

    return this.apiDocumentDocumentKeyMetadataPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

  /**
   * Path part for operation apiDocumentDocumentKeyArchivePost
   */
  static readonly ApiDocumentDocumentKeyArchivePostPath = '/api/Document/{documentKey}/archive';

  /**
   * Archive a document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocumentDocumentKeyArchivePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocumentDocumentKeyArchivePost$Json$Response(params: {
    documentKey: number;

  }): Observable<StrictHttpResponse<ProcessResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentService.ApiDocumentDocumentKeyArchivePostPath, 'post');
    if (params) {

      rb.path('documentKey', params.documentKey, {});

    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProcessResponse>;
      })
    );
  }

  /**
   * Archive a document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDocumentDocumentKeyArchivePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocumentDocumentKeyArchivePost$Json(params: {
    documentKey: number;

  }): Observable<ProcessResponse> {

    return this.apiDocumentDocumentKeyArchivePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
    );
  }

}
